import packageInfo from './configs.json';

export const environment = {
  production: true,
  log: false,
  defaultTheme: packageInfo.themes.litello,
  selectedTheme: "munv",
  allowedUsers: packageInfo.mails,
};
